import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCheck, faUsers, faExclamationTriangle, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import StatusIndicator from '../../../components/StatusIndicator';
import { usePageHeader } from '../../../layouts/AdminLayout';
import { 
  TabBadge,
  QueueTabsContainer,
  QueueTabButton,
  TabsBorderDiv
} from '../styled';

const PatientQueueHeader = ({ 
  activeTab, 
  onTabChange, 
  patientCounts = {}, 
  totalPatients = 0,
  loading = false,
  onStatusSettingsChange,
  statusSettings,
  selectedEvent
}) => {
  const { setPageHeader } = usePageHeader();

  // Set page header with dynamic props
  useEffect(() => {
    setPageHeader({
      title: 'Intake',
      count: totalPatients,
      countIcon: <FontAwesomeIcon icon={faUsers} />,
      loading: loading,
      loadingType: 'heart',
      enableNotificationPolling: true,
      actions: (
        <StatusIndicator 
          bookingId={selectedEvent !== 'all' ? selectedEvent : null}
          onSettingsChange={onStatusSettingsChange}
          initialSettings={statusSettings}
        />
      )
    });
  }, [setPageHeader, totalPatients, loading, selectedEvent, onStatusSettingsChange, statusSettings]);

  const tabs = [
    { key: 'active', icon: faUser, label: 'Active Queue', count: patientCounts.active || 0, activeColor: '#1890ff' },
    { key: 'completed', icon: faCheck, label: 'Recent Completions', count: patientCounts.completed || 0, activeColor: '#52c41a' },
    { key: 'pre_registered', icon: faClipboardList, label: 'Pre-Registered', count: patientCounts.preRegistered || 0, activeColor: '#722ed1' },
    { key: 'issues', icon: faExclamationTriangle, label: 'Issues', count: (patientCounts.needsAttention || 0) + (patientCounts.noShow || 0), activeColor: '#ff4d4f' },
  ];

  return (
    <div className="header-animate-in">
      <QueueTabsContainer>
        {tabs.map(tab => (
          <QueueTabButton
            key={tab.key}
            $active={activeTab === tab.key}
            onClick={() => onTabChange(tab.key)}
          >
            <FontAwesomeIcon icon={tab.icon} />
            {tab.label}
            <TabBadge color={activeTab === tab.key ? tab.activeColor : '#8c8c8c'}>
              {tab.count}
            </TabBadge>
          </QueueTabButton>
        ))}
      </QueueTabsContainer>
      <TabsBorderDiv />
    </div>
  );
};

export default PatientQueueHeader;
